import { render, staticRenderFns } from "./AssignmentSubmissions.vue?vue&type=template&id=71a70e78&"
import script from "./AssignmentSubmissions.vue?vue&type=script&lang=js&"
export * from "./AssignmentSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports